import {
  InvitePermissionOption,
  InvitePersonalAccount
} from '@/api/models/users/lib/invites.types'
import { AppSwitch } from '@/components/shared/switch'

type Props = {
  options: InvitePersonalAccount['permissions']
  selected: InvitePermissionOption[]
  onChange: (selectedPermission: InvitePermissionOption[]) => void
  isFullAccessSelected: boolean
}

export const PremisePermissionsPicker = ({
  options,
  onChange,
  isFullAccessSelected,
  selected
}: Props) => {
  const isAliasSelected = (alias: string) =>
    selected.some(item => item.alias === alias)

  const enableFullAccess = () => {
    onChange([...options.manualSelection, ...options.autoSelection])
  }

  const disableFullAccess = () => {
    onChange(options.autoSelection)
  }

  const onFullAccessChange = isFullAccessSelected
    ? disableFullAccess
    : enableFullAccess

  const togglePermission = (option: InvitePermissionOption) => {
    if (isAliasSelected(option.alias)) {
      onChange(selected.filter(item => item.alias !== option.alias))
    } else {
      onChange([...selected, option])
    }
  }

  return (
    <>
      <div className="flex cursor-pointer items-start gap-8">
        <AppSwitch
          className="mt-1"
          size="sm"
          checked={isFullAccessSelected}
          onChange={onFullAccessChange}
        />
        <button
          type="button"
          className="flex flex-col text-left"
          onClick={onFullAccessChange}
        >
          <span className="font-semibold text-16">Полный доступ</span>
          <p className="text-grey-70 text-14">Доступ во все разделы</p>
        </button>
      </div>
      <hr className="text-grey-20" />
      {options.manualSelection.map(option => (
        <div
          key={option.alias}
          className="flex cursor-pointer items-start gap-8"
        >
          <AppSwitch
            className="mt-1"
            size="sm"
            checked={isAliasSelected(option.alias)}
            onChange={() => togglePermission(option)}
          />
          <button
            type="button"
            className="flex flex-col text-left"
            onClick={() => togglePermission(option)}
          >
            <span className="font-semibold text-16">{option.name}</span>
            <p className="text-grey-70 text-14">{option.description}</p>
          </button>
        </div>
      ))}
      {options.autoSelection.map(option => (
        <div
          key={option.alias}
          className="flex cursor-pointer items-start gap-8"
        >
          <AppSwitch className="mt-1" size="sm" checked={true} disabled />
          <button type="button" className="flex flex-col text-left">
            <span className="font-semibold text-16">{option.name}</span>
            <p className="text-grey-70 text-14">{option.description}</p>
          </button>
        </div>
      ))}
    </>
  )
}
